Game.Utils.ManagePlatforms = {

	platforms: [],

	locked: false,
	lockedTo: false,

	init: function( layer ) {

		var paths = Game.Utils.Map.find_objects_by_type( 'path', Game.Utils.Map.map, 'objects' );

		paths.forEach(
			function( path ) {

				var platform = new Game.Prefabs.Platform( game, path, layer );

				Game.Utils.ManagePlatforms.platforms.push( platform );

			}
		);

	},


	collision_callback: function( player, platform ) {

		if ( ! Game.Utils.ManagePlatforms.locked && player.body.velocity.y > 0 ) {

			player.body.velocity.y = 0;
			player.locked = true;
			player.lockedTo = platform;

			player.state = Game.Prefabs.Man.states.WALK;

		}

	},


	update: function( man ) {

		if ( man.locked ) {
			this.checkLock( man );
		}

	},


	pre_render: function( man ) {

		//  Because preRender still runs even if your game pauses!
		if ( game.paused ) {
			return;
		}

		if ( man.locked ) {

			man.x += man.lockedTo.deltaX;
			man.y = man.lockedTo.y;

			man.body.velocity.y = 0;

		}

		this.platforms.forEach(
			function( platform ) {

				platform.preRender( man );

			}
		);

	},

	checkLock: function( man ) {

		if ( ! man.locked ) {
			return;
		}

		// If the player has walked off the edge of the platform.
		if ( man.body.right < man.lockedTo.left || man.body.left > man.lockedTo.right ) {
			this.cancelLock( man );
		}

	},

	cancelLock: function( man ) {

		man.locked = false;
		man.lockedTo = null;

	},

};